import React from "react";
import { Trans } from "react-i18next";

import Icon from "../../../components/Icon";
import { Direction } from "../../../components/Table/components/TableHeader/types";
import {
  ITableColumnConfig,
  ITableDataParams,
} from "../../../components/Table/types";
import { IPrincipalCommonData } from "../../../store/principal";

export const columns: ITableColumnConfig[] = [
  {
    field: "username",
    headerName: "Username / Email",
    cellClass: "ams-principal-database__cell ams-table__cell-content--text",
    valueGetter: ({ rowData }: ITableDataParams<IPrincipalCommonData>) => {
      if (!rowData) {
        return "";
      }
      if (rowData.username === rowData.email) {
        return rowData.username;
      }

      return `${rowData.username} (${rowData.email})`;
    },
  },
  {
    field: "name",
    headerName: "Name",
    cellClass: "ams-principal-database__cell ams-table__cell-content--text",
    valueGetter: ({ rowData }: ITableDataParams<IPrincipalCommonData>) => {
      if (!rowData) {
        return "";
      }
      return [rowData.name, rowData.surname].join(" ");
    },
  },
  {
    field: "tenant_code",
    headerName: "Tenant",
    cellClass: "ams-principal-database__cell",
    cellRenderer: ({ rowData }: ITableDataParams<IPrincipalCommonData>) => {
      if (!rowData) {
        return <div />;
      }
      return (
        <div className="ams-cell-tenant__content">
          <Icon className="ams-tenant-icon">{rowData.tenantIcon}</Icon>
          <span>
            <Trans>{rowData.tenant_code}</Trans>
          </span>
        </div>
      );
    },
  },
  {
    field: "created_at",
    headerName: "Creation Date",
    cellClass: "ams-principal-database__cell",
    defaultSort: "desc" as Direction,
    valueGetter: ({ rowData }: ITableDataParams<IPrincipalCommonData>) => {
      if (!rowData) {
        return "";
      }
      const createdAtDate = new Date(rowData.created_at);
      if (isNaN(Number(createdAtDate))) {
        return "";
      }
      const [, day, monthName, year] = createdAtDate.toUTCString().split(" ");
      return `${monthName} ${day}, ${year}`;
    },
  },
];
